import { CAPABILITY_NAMES } from './org.js';
export const ROLE_CAPABILITIES = {
    system_admin: CAPABILITY_NAMES,
    standard: [
        'records.read',
        'records.write',
        'records.delete',
        'records.export',
        'lists.create',
        'lists.share',
        'reminders.assign',
    ],
    limited: ['records.read', 'records.write', 'lists.create'],
    fully_limited: ['records.read.own', 'records.write', 'lists.create'],
    crm_lite: ['records.read', 'records.write.lite', 'lists.create'],
};
export const ROLE_SCOPE = {
    system_admin: 'all',
    standard: 'all',
    limited: 'department',
    fully_limited: 'own',
    crm_lite: 'own',
};
//# sourceMappingURL=roles.js.map